import { useGetMyClassGroups as useGetMyClassrooms } from '@/api/gen/classroom/classroom.gen';
import { useUser } from '@/lib/auth';
import { selectData } from '@/shared/utils';
import { type ContentShareType } from '../types';
interface UseClassroomLinkingParams {
  contentId: string;
  contentType: ContentShareType;
}

/**
 * 내 클래스 목록과 각 클래스에 이 콘텐츠가 연결돼 있는지를 한 번에 받는다.
 *
 * `linkedContentId`/`linkedContentType` 를 넘기면 응답의 각 클래스에 `isLinked`/`linkedClassLinkId`
 * 가 채워져 오므로 클래스마다 `getClassLinks` 를 부르지 않는다. 연결·해제 저장은 `useSaveClassroomLinks`.
 */
export function useClassroomLinking({
  contentId,
  contentType
}: UseClassroomLinkingParams) {
  const {
    isAuthenticated,
    isInitialized,
    user
  } = useUser();
  const canLoadClassrooms = isAuthenticated && user?.type?.toLowerCase() !== 'student';
  const {
    data: classrooms = [],
    isLoading: isLoadingClassrooms,
    isError: isClassroomsError
  } = useGetMyClassrooms({
    sortBy: 'updatedAt',
    order: 'desc',
    linkedContentId: contentId,
    linkedContentType: contentType
  }, {
    query: {
      enabled: canLoadClassrooms,
      select: selectData,
      // 실패를 빈 목록으로 그리지 않고 화면마다 `isClassroomsError` 로 다룬다. 전역 에러 화면으로 보내지 않는다.
      throwOnError: false,
      meta: {
        ignoreError: true
      }
    }
  });
  return {
    classrooms,
    isLoadingClassrooms,
    isClassroomsError,
    isInitialized
  };
}